export default __webpack_public_path__ + "static/media/0195.03e7b1c4.jpg";